import moment from 'moment'

import { isNil } from 'lodash'
import AtStatusRenderer from '../components/AtStatusRenderer.vue'
import CheckboxEditor from '../components/CheckboxEditor'
import CheckboxRenderer from '../components/CheckboxRenderer'
import DateCellRenderer from '../components/DateCellRenderer.vue'
import DateEditor from '../components/DateEditor'
import DefaultCellRenderer from '../components/DefaultCellRenderer.vue'
import FilterCollorCellRenderer from '../components/FilterCollorCellRenderer'
import LargeTextCellRenderer from '../components/LargeTextCellRenderer.vue'
import NumberCellRenderer from '../components/NumberCellRenderer'
import NumberEditor from '../components/NumberEditor'
import PciCustomCellEditor from '../components/PciCustomCellEditor.vue'
import PdrDepartamentoStatusRenderer from '../components/PdrDepartamentoStatusRenderer.vue'
import PdrStatusObraRenderer from '../components/PdrStatusObraRenderer.vue'
import PdrStatusRenderer from '../components/PdrStatusRenderer.vue'

const filterParams = {
  textFormatter: value => {
    const ret = value ? value
      .toLowerCase()
      .replace(/\s/g, '')
      .replace(/[àáâãäå]/g, 'a')
      .replace(/æ/g, 'ae')
      .replace(/ç/g, 'c')
      .replace(/[èéêë]/g, 'e')
      .replace(/[ìíîï]/g, 'i')
      .replace(/ñ/g, 'n')
      .replace(/[òóôõö]/g, 'o')
      .replace(/œ/g, 'oe')
      .replace(/[ùúûü]/g, 'u')
      .replace(/[ýÿ]/g, 'y')
      .replace(/\W/g, '') : '#NA#'

    return ret
  }
}

export default {
  components: {
    DefaultCellRenderer,
    DateCellRenderer,
    LargeTextCellRenderer,
    NumberEditor,
    NumberCellRenderer,
    DateEditor,
    CheckboxEditor,
    CheckboxRenderer,
    PdrStatusRenderer,
    PdrDepartamentoStatusRenderer,
    AtStatusRenderer,
    PdrStatusObraRenderer,
    FilterCollorCellRenderer,
    PciCustomCellEditor
  },
  data () {
    return {
      localeTextFunc: (params) => {
        return this.$lang.AGGrid[params.key] ? this.$lang.AGGrid[params.key] : params.defaultValue
      },
      gridOptions: {
        groupHeaderHeight: 20,
        headerHeight: 20,
        rowHeight: 20
      },
      columnTypes: {
        smallColumn: {
          filter: 'agMultiColumnFilter',
          minWidth: 30,
          filterParams: {
            filters: [
              {
                filter: 'agTextColumnFilter',
                display: 'accordion',
                title: this.$lang.PCI.Spreadsheet.CustomizedFilter,
                filterParams: filterParams
              },
              {
                filter: 'agSetColumnFilter',
                filterParams: filterParams
              }
            ]
          },
          cellRendererSelector: (params) => {
            return {
              component: 'DefaultCellRenderer',
              params: {
                value: params.value
              }
            }
          }
        },
        numberZeroColumn: {
          headerClass: 'ag-right-aligned-header',
          cellClass: (params) => this.getCellClass(params, 'floatType'),
          filter: 'agMultiColumnFilter',
          minWidth: 100,
          filterParams: {
            filters: [
              {
                filter: 'agNumberColumnFilter',
                display: 'accordion',
                title: this.$lang.PCI.Spreadsheet.CustomizedFilter
              },
              {
                filter: 'agSetColumnFilter',
                filterParams: {
                  valueFormatter: params => {
                    let value = params.value
                    if (value !== '#NA#' && value !== '#NREF#') {
                      if (typeof params.value === 'string') {
                        value = Number.parseFloat(params.value.replaceAll(',', '.'))
                      }
                      try {
                        value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2}) : null
                      } catch (error) {
                        value = null
                        console.log(error)
                      }
                    }
                    return value
                  }
                }
              }
            ]
          },
          cellEditor: 'NumberEditor',
          cellEditorParams: {
            withNegative: true
          },
          cellRenderer: 'NumberCellRenderer'
          // cellRendererSelector: (params) => {
          //   let value = params.value
          //   if (value !== '#NA#' && value !== '#NREF#') {
          //     if (typeof params.value === 'string') {
          //       value = Number.parseFloat(params.value.replaceAll(',', '.'))
          //     }
          //     try {
          //       value = !isNil(value) ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 8}) : null
          //     } catch (error) {
          //       value = null
          //       console.log(error)
          //     }
          //   }
          //   return {
          //     component: 'DefaultCellRenderer',
          //     params: {
          //       value: value
          //     }
          //   }
          // }
        },
        numberColumn: {
          headerClass: 'ag-right-aligned-header',
          cellClass: (params) => this.getCellClass(params, 'floatType'),
          filter: 'agMultiColumnFilter',
          minWidth: 100,
          filterParams: {
            filters: [
              {
                filter: 'agNumberColumnFilter',
                display: 'accordion',
                title: this.$lang.PCI.Spreadsheet.CustomizedFilter
              },
              {
                filter: 'agSetColumnFilter',
                filterParams: {
                  valueFormatter: params => {
                    let value = params.value === '' ? null : params.value
                    if (value !== '#NA#' && value !== '#NREF#') {
                      if (typeof params.value === 'string') {
                        value = Number.parseFloat(params.value.replaceAll(',', '.'))
                      }
                      try {
                        value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2}) : null
                      } catch (error) {
                        value = null
                        console.log(error)
                      }
                    }
                    return value
                  }
                }
              }
            ]
          },
          cellEditor: 'NumberEditor',
          cellEditorParams: {
            withNegative: true
          },
          cellRenderer: 'NumberCellRenderer'
        },
        integerColumn: {
          headerClass: 'ag-right-aligned-header',
          cellClass: (params) => this.getCellClass(params, 'integerType'),
          filter: 'agMultiColumnFilter',
          minWidth: 100,
          filterParams: {
            filters: [
              {
                filter: 'agNumberColumnFilter',
                display: 'accordion',
                title: this.$lang.PCI.Spreadsheet.CustomizedFilter
              },
              {
                filter: 'agSetColumnFilter'
              }
            ]
          },
          cellEditor: 'NumberEditor',
          cellEditorParams: {
            withNegative: true,
            maxFraction: 0
          },
          cellRendererSelector: (params) => {
            let value = params.value === '' ? null : params.value
            if (value !== '#NA#' && value !== '#NREF#') {
              if (typeof value === 'string') {
                value = Number.parseInt(value.replaceAll(',', '.'))
              }
              try {
                value = !isNil(value) && !Number.isNaN(value) ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0}) : null
              } catch (error) {
                value = null
                console.log(error)
              }
            }
            return {
              component: 'DefaultCellRenderer',
              params: {
                value: value
              }
            }
          }
        },
        percentColumn: {
          headerClass: 'ag-right-aligned-header',
          cellClass: (params) => this.getCellClass(params, 'percentType'),
          filter: 'agMultiColumnFilter',
          minWidth: 100,
          filterParams: {
            filters: [
              {
                filter: 'agNumberColumnFilter',
                display: 'accordion',
                title: this.$lang.PCI.Spreadsheet.CustomizedFilter
              },
              {
                filter: 'agSetColumnFilter',
                filterParams: {
                  valueFormatter: params => {
                    let value = params.value
                    if (value !== '#NA#' && value !== '#NREF#') {
                      if (typeof params.value === 'string') {
                        value = Number.parseFloat(params.value.replaceAll(',', '.'))
                      }
                      try {
                        value = value ? value.toLocaleString('pt-BR', {style: 'percent', minimumFractionDigits: 1, maximumFractionDigits: 1}) : null
                      } catch (error) {
                        value = null
                        console.log(error)
                      }
                    }
                    return value
                  }
                }
              }
            ]
          },
          cellEditor: 'NumberEditor',
          cellRendererSelector: (params) => {
            let value = params.value
            if (value !== '#NA#' && value !== '#NREF#') {
              if (typeof params.value === 'string') {
                value = Number.parseFloat(params.value.replaceAll(',', '.'))
              }
              try {
                value = value ? value.toLocaleString('pt-BR', {style: 'percent', minimumFractionDigits: 1, maximumFractionDigits: 1}) : null
              } catch (error) {
                value = null
                console.log(error)
              }
            }
            return {
              component: 'DefaultCellRenderer',
              params: {
                value: value
              }
            }
          }
        },
        memoColumn: {
          filter: 'agTextColumnFilter',
          maxWidth: 2000,
          minWidth: 200,
          cellEditor: 'PciCustomCellEditor',
          cellEditorPopup: true,
          cellClass: (params) => this.getCellClass(params, 'ag-wrap-text'),
          suppressPaste: true,
          cellEditorParams: {
            maxLength: 40000,
            cols: 80,
            rows: 25
          },
          cellRendererSelector: (params) => {
            return {
              component: 'LargeTextCellRenderer',
              params: {
                value: params.value
              }
            }
          }
        },
        textColumn: {
          filter: 'agMultiColumnFilter',
          minWidth: 100,
          cellClass: (params) => this.getCellClass(params),
          filterParams: {
            filters: [
              {
                filter: 'agTextColumnFilter',
                display: 'accordion',
                title: this.$lang.PCI.Spreadsheet.CustomizedFilter,
                filterParams: filterParams
              },
              {
                filter: 'agSetColumnFilter',
                filterParams: filterParams
              }
            ]
          },
          cellRendererSelector: (params) => {
            return {
              component: 'DefaultCellRenderer',
              params: {
                value: params.value
              }
            }
          }
        },
        booleanColumn: {
          cellRenderer: 'CheckboxRenderer',
          cellEditor: 'CheckboxEditor',
          minWidth: 100,
          filterParams: {
            valueGetter: params => {
              const value = params.data[params.colDef.field] || null
              return (value !== '#NA#' && value !== '#NREF#' && value !== null && value.toString() === 'true') ? 'VERDADEIRO' : (value === null || value.toString() === 'false') ? 'FALSO' : value
            },
            comparator: (valueA, valueB) => {
              var cellValueA, cellValueB
              if (valueA === '#NA#' || valueA === '#NREF#') {
                cellValueA = -1
              } else {
                cellValueA = (valueA && valueA.toString() === 'true')
              }
              if (valueB === '#NA#' || valueB === '#NREF#') {
                cellValueB = -1
              } else {
                cellValueB = (valueB && valueB.toString() === 'true')
              }
              return cellValueA - cellValueB
            }
          }
        },
        dateColumn: {
          filter: 'agMultiColumnFilter',
          cellClass: (params) => this.getCellClass(params, 'dateType'),
          minWidth: 100,
          filterParams: {
            filters: [
              {
                filter: 'agDateColumnFilter',
                display: 'accordion',
                title: this.$lang.PCI.Spreadsheet.CustomizedFilter,
                filterParams: {
                  comparator: (filterDate, cellValue) => {
                    if (cellValue == null) return -1
                    return cellValue && cellValue !== '#NA#' && cellValue !== '#NREF#' ? moment(cellValue).toDate() - filterDate : -1
                  }
                }
              },
              {
                filter: 'agSetColumnFilter',
                filterParams: {
                  comparator: (dateA, dateB) => {
                    var cellDateA, cellDateB
                    if (!dateA || dateA === '#NA#' || dateA === '#NREF#') {
                      cellDateA = -1
                    } else {
                      cellDateA = moment(dateA).toDate()
                    }
                    if (!dateB || dateB === '#NA#' || dateB === '#NREF#') {
                      cellDateB = -1
                    } else {
                      cellDateB = moment(dateB).toDate()
                    }
                    return cellDateA < cellDateB ? -1 : cellDateA > cellDateB ? 1 : 0
                  },
                  valueFormatter: params => {
                    if (params.value) {
                      let format = ''
                      const mt1 = params.value.match(/^\d\d\/\d\d\/\d\d\d\d$/g)
                      const mt2 = params.value.match(/^\d\d\/\d\d\/\d\d$/g)
                      if (mt1) format = 'dd/MM/yyyy'
                      if (mt2) format = 'dd/MM/yy'
                      return params.value !== '#NA#' && params.value !== '#NREF#' ? moment(params.value, format).toDate().toLocaleDateString() : null
                    }
                    return null
                  }
                }
              }
            ]
          },
          valueFormatter: params => {
            if (params.value) {
              let format = ''
              const mt1 = params.value.match(/^\d\d\/\d\d\/\d\d\d\d$/g)
              const mt2 = params.value.match(/^\d\d\/\d\d\/\d\d$/g)
              if (mt1) format = 'dd/MM/yyyy'
              if (mt2) format = 'dd/MM/yy'
              return params.value !== '#NA#' && params.value !== '#NREF#' ? moment(params.value, format).toDate().toLocaleDateString() : null
            }
            return null
          },
          cellEditor: 'DateEditor',
          cellRendererSelector: (params) => {
            return {
              component: 'DateCellRenderer',
              params: {
                value: params.value
              }
            }
          }
        },
        valuesColumn: {
          filterParams: filterParams,
          cellEditor: 'agRichSelectCellEditor',
          minWidth: 100,
          cellRendererSelector: (params) => {
            return {
              component: 'DefaultCellRenderer',
              params: {
                value: params.value
              }
            }
          }
        },
        attachmentColumn: {
          cellRenderer: 'AttachmentCellRenderer',
          cellEditor: 'AttachmentEditor',
          minWidth: 100
        },
        pdrStatusObraColumn: {
          cellRenderer: 'PdrStatusObraRenderer',
          filter: 'agSetColumnFilter',
          minWidth: 100,
          filterParams: {
            valueFormatter: params => {
              return this.$lang.PCI.PDR.StatusObra['_' + params.value]
            }
          }
        },
        pdrStatusColumn: {
          cellRenderer: 'PdrStatusRenderer',
          filter: 'agSetColumnFilter',
          minWidth: 100,
          filterParams: {
            valueFormatter: params => {
              return this.$lang.PCI.PDR.Status['_' + params.value]
            }
          }
        },
        pdrDepartamentoStatusColumn: {
          cellRenderer: 'PdrDepartamentoStatusRenderer',
          filter: 'agSetColumnFilter',
          minWidth: 100,
          filterParams: {
            valueFormatter: params => {
              return this.$lang.PCI.PDR.StatusDepartament['_' + params.value]
            }
          }
        },
        atStatusColumn: {
          cellRenderer: 'AtStatusRenderer',
          filter: 'agSetColumnFilter',
          minWidth: 100,
          filterParams: {
            valueFormatter: params => {
              return this.$lang.PCI.AT['Status' + params.value]
            }
          }
        }
      },
      excelStyles: [
        {
          id: 'header',
          alignment: {
            vertical: 'Center'
          },
          interior: {
            color: '#504d4d',
            pattern: 'solid'
          },
          font: {
            color: '#ffffff'
          }
        },
        {
          id: 'headerGroup',
          alignment: {
            vertical: 'Center'
          },
          interior: {
            color: '#008143',
            pattern: 'solid'
          }
        },
        {
          id: 'rowOdd',
          interior: {
            color: '#e0efe7',
            pattern: 'solid'
          }
        },
        {
          id: 'rowCount',
          font: {
            bold: true
          },
          alignment: {
            horizontal: 'Center'
          },
          numberFormat: {
            format: '#,##0'
          }
        },
        {
          id: 'rowSum',
          dataType: 'Number',
          font: {
            bold: true
          },
          alignment: {
            horizontal: 'Center'
          },
          numberFormat: {
            format: '#,###.##;;'
          }
        },
        {
          id: 'integerType',
          dataType: 'Number',
          numberFormat: {
            format: '#,##0'
          }
        },
        {
          id: 'floatType',
          dataType: 'Number',
          numberFormat: {
            format: '#,##0.00'
          }
        },
        {
          id: 'dateType',
          dataType: 'DateTime',
          numberFormat: {
            format: 'dd/mm/yyyy'
          }
        },
        {
          id: 'ag-wrap-text',
          dataType: 'String',
          alignment: {
            wrapText: true
          }
        },
        {
          id: 'ag-right-aligned-cell',
          dataType: 'String',
          alignment: {
            horizontal: 'Right'
          }
        }
      ],
      defaultColumnDef: {
        filter: 'agSetColumnFilter',
        floatingFilter: false,
        cellRenderer: 'DefaultCellRenderer',
        resizable: true,
        editable: false,
        suppressMenu: false,
        sortable: true,
        enableRowGroup: true,
        suppressMovable: true,
        cellClass: (params) => this.getCellClass(params)
      }
    }
  },
  methods: {
    navigateToNextCell (params) {
      const suggestedNextCell = params.nextCellPosition

      const KEY_UP = 'ArrowUp'
      const KEY_DOWN = 'ArrowDown'

      const noUpOrDownKeyPressed = params.key !== KEY_DOWN && params.key !== KEY_UP
      if (noUpOrDownKeyPressed) {
        return suggestedNextCell
      }

      params.api.forEachNode(node => {
        if (node.rowIndex === suggestedNextCell.rowIndex) {
          node.setSelected(true)
        }
      })

      return suggestedNextCell
    },
    getCellClass (params, vclass) {
      if (this.alerts && this.alerts.length && (
        this.alerts.some(a => (
          a.pciModeloItemValid.pciModeloItemID === params.column.colId ||
            params.column.colId === 'referencia'
        ) &&
        params.data &&
        a.obraID === params.data.obraId &&
        (a.obraCandidatoID || '00000000-0000-0000-0000-000000000000') === params.data.obraCandidatoId)
      )) {
        return vclass ? [vclass, 'field-with-alert'] : 'field-with-alert'
      }
      if (params.column.colDef.ItemFormula && params.data && params.data.possuiNotasDig.includes(params.column.colId)) {
        return vclass ? [vclass, 'field-formula-with-invoice'] : 'field-formula-with-invoice'
      }
      return vclass || ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/mixins/gridMixin.js